// client/src/config/apiConfig.js
// API-bas + Google Maps-nyckel. Auto-väljer localhost-backend i dev och
// Railway-backend i prod baserat på window.location.hostname.
const API_CONFIG = {
  baseUrl: (() => {
    if (typeof window === 'undefined') {
      return 'https://health-data-demo4vercelapp-production.up.railway.app/api';
    }

    // ✅ AUTO-SWITCH: Localhost för utveckling, Railway för production
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      console.log('🔧 DEV MODE: Using localhost backend');
      return 'http://localhost:5000/api';
    }

    // Production: Railway backend
    return 'https://health-data-demo4vercelapp-production.up.railway.app/api';
  })(),

  // 🔒 SECURE: Ta bort hårdkodad fallback API-nyckel
  googleMapsApiKey: (() => {
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    
    // Development vs Production handling
    if (process.env.NODE_ENV === 'development') {
      // Development: Mer detaljerad error handling
      if (!apiKey) {
        console.error('🚨 GOOGLE_MAPS_API_KEY saknas i environment variables!');
        console.error('💡 Lägg till REACT_APP_GOOGLE_MAPS_API_KEY i .env fil');
        return 'MISSING_DEV_API_KEY';
      }
      return apiKey;
    }
    
    // Production: Tyst error handling
    if (!apiKey) {
      console.error('🚨 Google Maps API key saknas!');
      return 'MISSING_API_KEY';
    }
    
    return apiKey;
  })()
};

export default API_CONFIG;
